import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  Stack,
  Button,
  FormControlLabel,
  Drawer,
} from '@mui/material';
// ICONS
import Checkbox from '@mui/material/Checkbox';
// STORE
import { updateSubmissionCountdownSettings } from '../../../../store/SubmissionSlice';
// CONSTANTS
import { TP_COLORS } from '../../../../constants';
// HELPERS
import { isMobileScreen, SafeAreaGaps } from '../../../../helper';

interface ContinueWithTimerModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ContinueWithTimerModal: React.FC<ContinueWithTimerModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  // HOOKS
  const dispatch = useDispatch();
  const params = useParams();

  // STATE
  const [isChecked, setChecked] = useState(true);

  // BOOLEANS
  const isMobile = isMobileScreen();

  // METHODS
  const handleCheckChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setChecked(checked);
  };

  const onSubmit = (isContinueSubmissionWithTimerEnabled: boolean) => {
    if (params && params.submissionId) {
      dispatch(
        updateSubmissionCountdownSettings({
          rememberOption: isChecked,
          isContinueSubmissionWithTimerEnabled,
          submissionId: params.submissionId,
        })
      );
    }

    onConfirm();

    onClose();
  };

  const RENDER_CONTENTS = () => {
    return (
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6}>
            <div style={{ textAlign: 'center' }}>
              <img
                src={`${process.env.PUBLIC_URL}/images/countdown/count-down-timer-settings.png`}
                alt="countdown-timer"
                style={{ width: '90%', maxWidth: '90vw' }}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div style={{ marginBottom: '15px' }}>
              <Typography variant="h5">Simulate Exam Conditions?</Typography>
            </div>
            {/* <div style={{ marginBottom: '30px' }}>
              <Typography fontWeight={500} color="secondary">
                Lorem ipsum doro sit amet, consectetur adipiscing elit. Duis
                porta pharetra odio, congue aliquam enim gravida a. Vestib ulum
                semper
              </Typography>
            </div> */}
            <div>
              <ul>
                <Typography
                  component="li"
                  variant="subtitle2"
                  fontWeight={500}
                  color="secondary"
                  style={{ marginBottom: '15px' }}
                >
                  Yes - prepare me for my exam!
                </Typography>
                <Typography
                  component="li"
                  variant="subtitle2"
                  fontWeight={500}
                  color="secondary"
                  style={{ marginBottom: '15px' }}
                >
                  No - let me take my own time!
                </Typography>
              </ul>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  if (isMobile) {
    return (
      <Drawer
        open={open}
        anchor="bottom"
        PaperProps={{
          sx: {
            borderTopLeftRadius: '12px',
            borderTopRightRadius: '12px',
            maxHeight: '90vh',
          },
        }}
      >
        <div
          style={{ padding: `calc(30px + ${SafeAreaGaps.top}) 15px 15px 15px` }}
        >
          {RENDER_CONTENTS()}
        </div>
        <div
          style={{
            marginBottom: '15px',
            padding: `15px 15px calc(15px + ${SafeAreaGaps.bottom}) 15px`,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Grid
            container
            spacing={2}
            alignItems="center"
            style={{ maxWidth: '400px' }}
          >
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox checked={isChecked} onChange={handleCheckChange} />
                }
                label="Don't ask me again"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={() => onSubmit(true)}
              >
                Yes
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                fullWidth
                color="inherit"
                variant="contained"
                style={{ color: TP_COLORS.black, marginRight: '15px' }}
                onClick={() => onSubmit(false)}
              >
                No
              </Button>
            </Grid>
          </Grid>
        </div>
      </Drawer>
    );
  }

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          minWidth: { xs: 'unset', sm: '600px', md: '700px', xl: '800px' },
          maxWidth: { xs: 'unset', sm: '600px', md: '700px', xl: '800px' },
        },
      }}
    >
      <DialogContent>
        <div style={{ padding: '100px 15px 15px 15px' }}>
          {RENDER_CONTENTS()}
        </div>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pl: '30px',
          pr: '30px',
          pb: '30px',
        }}
      >
        <div>
          <FormControlLabel
            control={
              <Checkbox checked={isChecked} onChange={handleCheckChange} />
            }
            label="Don't ask me again"
          />
        </div>
        <Stack direction="row" alignItems="center">
          <Button
            color="inherit"
            variant="contained"
            style={{ color: TP_COLORS.black, marginRight: '15px' }}
            onClick={() => onSubmit(false)}
          >
            No
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => onSubmit(true)}
          >
            Yes
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default ContinueWithTimerModal;
